import styled from 'styled-components';

export const ContentWrapper = styled.div`
  margin: 2rem 0;

  & .MuiButton-root {
    font-size: 0.875rem;
  }
`;
